<template>
	<core-save-button
		v-bind="$attrs"
		v-on="$listeners"
		:href="upgradeUrl"
		target="_blank"
		@click.prevent="openComms"
		successText="Upgrade Complete! (Reloading)"
		errorText="Upgrade incomplete!"
		:saving="isLoading"
		:disabled="isLoading"
		:failed="failed"
	>
		<slot>Upgrade Now &amp; Save 35%</slot>
	</core-save-button>
</template>
<script lang="js">
import { featureMap } from '@/wizard/data'
import { getAppData, debug } from '@/utils'

export default  {
	inheritAttrs : false,
	props        : {
		utmMedium : {
			type     : String,
			required : true,
		},
		features : {
			type    : Array,
			default : () => [],
		},
	},
	data () {
		return {
			tab    : null,
			failed : false,
		}
	},
	computed : {
		upgradeUrl () {
			// Get non-plugin features.
			const features = this.features.filter(f => {
				const found = !featureMap.find(m => m.slug === f)
				return !found || !found.plugin
			})

			return this.$urls.upgrade({ utm_medium: this.utmMedium }, features)
		},
		isLoading () {
			return this.$store.getters.isLoading('upgrade')
		},
	},
	methods : {
		openComms (event) {
			this.tab = window.open(this.upgradeUrl, '_blank')
			this.$store.commit('loading', 'upgrade')
			window.addEventListener('message', this.listenMessage)
			this.failed = false

			// Continue checking to see if upgrade is still in process.
			this.interval = setInterval(() => this.maybeDetach(), 2000)
		},
		listenMessage (evt) {
			const { origin, data } = evt
			if (origin.replace(/\/$/, '') !== this.$urls.app().replace(/\/$/, '')) {
				return
			}

			if (!data || 'string' !== typeof data) {
				return
			}

			try {
				// Get passed status.
				const data = JSON.parse(evt.data)

				if (!data.omWizard) {
					throw new Error('no')
				}

				if (debug.enabled('upgrade')) {
					console.warn('10-4', data.status, { data })
				}

				// Do action based on status.
				switch (data.status) {
				case 'loaded':
					this.onUpgradeLoaded(data)
					break
				case 'upgraded':
				case 'complete':
					this.reload()
					break
				default:
				}
			} catch (error) {
				if (debug.enabled('upgrade')) {
					console.warn('error', { error })
				}
			}
		},
		onUpgradeLoaded (data) {
			const payload = {
				siteName  : getAppData('blogname'),
				partnerId : getAppData('partnerId'),
				user      : {
					email     : this.userEmail,
					firstName : this.userFirstName,
					lastName  : this.userLastName,
				},
			}

			this.message(payload)
		},
		message (payload) {
			if (this.maybeDetach()) {
				return
			}

			payload = {
				...payload,
				omWizard : true,
				status   : 'loaded',
				origin   : window.location.protocol + '//' + window.location.host,
			}

			this.tab.postMessage(JSON.stringify(payload), this.$urls.app())
		},
		maybeDetach () {
			if (this.tab.closed) {
				this.detach()
				return true
			}
			return false
		},
		detach () {
			this.failed = true
			this.$store.commit('doneLoading', 'upgrade')
			window.removeEventListener('message', this.listenMessage)
			clearInterval(this.interval)
		},
		reload () {
			this.$store.commit('doneLoading', 'upgrade')
			window.location.reload()
		},
	},
	beforeDestroy () {
		this.detach()
	},
}
</script>
